import React, { useContext, useEffect, useState } from 'react'
import { moneyFormatter, SHIPPING_TYPES } from '../../../../utils'
import { useEffectOnce } from 'react-use'
import { QuickOrderContext } from '../../../context/QuickOrderContext'

function TotalPriceInfo(props: any) {
    const { shippingPreference } = props
    const [summaryTotalPrice, setSummaryTotalPrice] = useState<any>(null)
    const { getComputeSummaryTotal, prepareOrderRecalcAsync, requiresSemi } = useContext(QuickOrderContext)


    useEffectOnce(() => {
        const calculateSummary = async () => {
            try {
                const data = await prepareOrderRecalcAsync();
                setSummaryTotalPrice(data);
            } catch (error) {
                console.error("Failed to recalculate summary:", error);
            }
        };
        calculateSummary();
    })


    return (
        <div className='col-md-4'>
            <div className='d-flex flex-column align-items-center' style={{ height: '100%' }}>
                {
                    summaryTotalPrice && (
                        <React.Fragment>
                            <div
                                className='w-100 p-4'
                                style={{
                                    backgroundColor: 'rgb(204, 204, 204)',
                                    height: 'auto',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                }}
                            >

                                <div>
                                    <div className='d-flex flex-row justify-content-between align-items-center'>
                                        <p className='fw-bolder text-dark'>Product Total Fee (ex. GST)</p>
                                        <p className='fw-bolder text-dark'> {moneyFormatter.format(summaryTotalPrice?.productTotalFee)}</p>
                                    </div>
                                    <div className='d-flex flex-row justify-content-between align-items-center'>
                                        <p className='fw-bolder text-dark'>Delivery Fee{requiresSemi ? '(Semi):' : ':'}  </p>

                                        <p className='fw-bolder text-dark'>
                                            {((shippingPreference?.shipping ?? '') == SHIPPING_TYPES.DELIVERY && (summaryTotalPrice?.miscFee ?? 0) <= 0) ? 'TBC' : moneyFormatter.format(summaryTotalPrice?.miscFee ?? 0)}
                                        </p>
                                    </div>
                                    <div className='d-flex flex-row justify-content-between align-items-center'>
                                        <p className='fw-bolder text-dark'>GST</p>
                                        <p className='fw-bolder text-dark'>{moneyFormatter.format(summaryTotalPrice?.totalGST)}</p>
                                    </div>
                                </div>

                                <div>
                                    <hr />
                                    <div className='d-flex flex-row justify-content-between align-items-center'>
                                        <p className='fw-bolder  mb-0' style={{ fontSize: '1.75rem' }}>
                                            TOTAL
                                        </p>

                                        <p className='fw-bolder mb-0' style={{ fontSize: '1.75rem' }}>
                                            {moneyFormatter.format(summaryTotalPrice?.totalProductAmount)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <p className='fw-bolder text-center my-4 ' style={{ fontSize: '1.05rem', color: '#f00' }}>
                                ** Below ONLY applies if paying by Credit Card **
                            </p>
                            <div
                                className='w-100 p-4'
                                style={{
                                    backgroundColor: 'rgb(204, 204, 204)',
                                    height: 'auto',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <div className='d-flex flex-row justify-content-between align-items-center'>
                                    <p className='fw-bolder text-dark'>Credit Card Payment Fee (0.75%)</p>
                                    <p className='fw-bolder text-dark'>
                                        {moneyFormatter.format(summaryTotalPrice?.creditcardFee)}
                                    </p>
                                </div>
                                <hr />
                                <div className='d-flex flex-row justify-content-between align-items-center'>
                                    <div>
                                        <p className='fw-bolder  mb-0' style={{ fontSize: '1.75rem' }}>
                                            TOTAL
                                        </p>
                                        <p className='mb-0 fw-bolder text-dark'>(With Credit Card Fee)</p>
                                    </div>
                                    <p className='fw-bolder mb-0' style={{ fontSize: '1.75rem' }}>
                                        {moneyFormatter.format(summaryTotalPrice?.totalAmount)}
                                    </p>
                                </div>
                            </div>
                        </React.Fragment>
                    )
                }

            </div>
        </div>
    )
}

export default TotalPriceInfo
